enum ColorFormat {
    RGBA = "rgba",
    HexRGBA = "hexRGBA",
    HexARGB = "hexARGB",
    HSL = "hsl"
}

export default ColorFormat;
